export const PageRoutes = {
  // Auth Pages
  DEFAULT: "/",
  LOGIN: "/login",
  OTPVERIFY: "/otp-verify",
  FORGOTPASSWORD: "/forgot-password",
  RESETPASSWORDOTPVERIFY: "/otp-verify-forgot-password",
  RESETPASSWORD: "/reset-password",

  // Un Auth Pages
  DASHBOARD: "/dashboard",
  NEWSLETTER: '/newsletters',
  PROACCOUNTS: '/pro-accounts',
  PORTFOLIOS: 'portfolios',
  LISTICONS: '/list-icons',
  REFERALTRACKING: '/referral-tracking',
  COMPAIGNS: '/campaigns',
  ANGLERSENGAGEMENT: 'anglers-engagement',
  WATERBODIESCOMPAIGN: 'waterbodies-campaign',
  REENGAGEMENT: 'reengagement',
  NEWSLETTERS: 'newsletters',
  FISHINITYPROCENTER: '/fishinity-pro-center',
  ACCOUNTSETTINGS : '/account-settings',
  USERSETTINGS : 'users-settings',
  SPONSORESUSERS: '/sponsored-users',
  PAGENOTFOUND: '*'
  
} as const;
